import Apart from "./Apart";

export default Apart;
